import { Box, Stack, Typography } from '@mui/material'
import { Driver } from '../../../store/drivers/drivers.type'
import DriverSelection from '../driver-selection/driver-selection.component'
import { useDispatch } from 'react-redux'
import { clearSelectedDriver } from '../../../store/drivers/drivers.slice'
import ArrowLeft from '../../../assets/icons/ArrowLeft.png'
import DriverDetails from '../driver-details/driver-details.component'

interface MobileDriverSelectionProps {
  selectedDriver: Driver
}

const MobileDriverSelection = ({
  selectedDriver,
}: MobileDriverSelectionProps) => {
  const dispatch = useDispatch()

  return (
    <>
      {!selectedDriver?.id ? (
        <Box p={2}>
          <DriverSelection />
        </Box>
      ) : (
        <Stack spacing={1}>
          <Stack
            direction="row"
            sx={{ cursor: 'pointer', alignItems: 'center' }}
            onClick={() => dispatch(clearSelectedDriver())}
          >
            <Box px={1} pt={1}>
              <img src={ArrowLeft} alt="arrow left" width={24} height={24} />
            </Box>
            <Typography>Go Back</Typography>
          </Stack>
          <DriverDetails />
        </Stack>
      )}
    </>
  )
}

export default MobileDriverSelection
